import Vue from 'vue'
import Router from 'vue-router'
import World from '@/components/World'
import Admin from '@/components/Admin'
import languages from '../assets/chapters.json'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: World,
      meta: {
        breadcrumb: 'Rooftop',
        zoneIndex: 0
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/rooftop',
      name: 'Rooftop',
      component: World,
      meta: {
        breadcrumb: 'Rooftop',
        breadcrumbImage: './static/img/rooftopThumb.png',
        zoneIndex: 0
      },
      children: convertChaptersToRoutes()
    },
    {
      path: '*',
      name: 'Hello',
      component: World,
      meta: {
        breadcrumb: 'Rooftop',
        zoneIndex: 0
      }
    }
  ]
})

function convertChaptersToRoutes () {
  let languageIndex = 0
  for (let i = 0; i < languages.length; i++) {
    if (languages[i].language === window.localStorage['vue-lang']) {
      languageIndex = i
    }
  }
  let chapters = languages[languageIndex].chapters
  return chapters.map((chapter, i) => {
    let chapterIndex = i + 1
    let chapterUrlComponent = stringToUrlComponent(chapter.key)
    return {
      path: `/overview/${chapterUrlComponent}`,
      component: World,
      meta: {
        breadcrumb: chapter.title,
        zoneIndex: chapterUrlComponent
      },
      children: chapter.subChapters.map((subChapter, i) => {
        let subChapterIndex = i + 1
        let subChapterUrlComponent = stringToUrlComponent(subChapter.title)
        return {
          path: `/overview/${chapterUrlComponent}/${subChapterUrlComponent}`,
          component: World,
          meta: {
            breadcrumb: subChapter.title,
            zoneIndex: `${chapterIndex}.${subChapterIndex}`
          }
        }
      })
    }
  })
}

function stringToUrlComponent (string) {
  return string.split(' ').join('-').toLowerCase().replace(/[^a-z0-9-]/g, '')
}



// WEBPACK FOOTER //
// ./src/router/index.js